<template>
  <div>
    <el-dialog
      title="添加异常"
      :visible.sync="showEdit"
      @close="remarkClose"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add markup-t">
        <order-row ref="orderRow" :info="remarkInfo"></order-row>
        <div class="increase_price_form">
          <el-form
            :model="params"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-row :gutter="36">
              <el-col :span="8">
                <el-form-item label="来源人" prop="name">
                  <el-select
                    class="default-input"
                    v-model="params.source"
                    placeholder="请选择"
                    @change="onSource"
                  >
                    <el-option
                      v-for="item in sourceList"
                      :label="
                        item.itemValue != 'qt'
                          ? item.itemText + ' ' + item.itemValue
                          : item.itemText
                      "
                      :value="
                        item.itemValue == 'qt'
                          ? item.itemValue
                          : item.itemText + ',' + item.itemValue
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="inputs" v-if="params.source == 'qt'">
                <el-input
                  class="default-input"
                  v-model="params.sourceName"
                  placeholder="请输入姓名"
                  maxlength="100"
                ></el-input>
                <el-input
                  class="default-input"
                  v-model="params.sourcePhone"
                  placeholder="请输入联系方式"
                  maxlength="11"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-form-item label="异常类型" prop="abnormalType">
                  <el-select
                    class="default-input"
                    v-model="params.abnormalType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.itemText"
                      :value="item.itemValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="涉及商品" prop="orderItemId">
                  <el-checkbox-group v-model="params.orderItemId">
                    <el-checkbox-button
                      v-for="(item, index) in remarkInfo.orderItems"
                      :label="item.id"
                      :key="index"
                    >
                      <div class="imgs">
                        <div class="sanjiao">
                          <i class="el-icon-check"></i>
                        </div>
                        <img :src="item.imgUrl" />
                        <div class="count">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="item.name"
                            placement="bottom"
                            popper-class="wuliutooltip"
                            :visible-arrow="false"
                          >
                            <span class="span">{{ item.name }}</span>
                          </el-tooltip>
                        </div>
                      </div>
                    </el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="异常描述" prop="description">
                  <el-input
                    class="default-input default-input-remark"
                    v-model="params.description"
                    placeholder="请输入备注信息"
                    type="textarea"
                    :maxlength="500"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="异常图片"
                  class="complaint-img eva-upload-imgs genjinupload"
                >
                  <a-upload
                    accept="image/*"
                    :action="baseApl + '/common/common/upload_file'"
                    listType="picture-card"
                    :fileList="followUpList"
                    @change="followUpChange"
                    @preview="handlePreview"
                    :data="webToken"
                    :headers="webToken"
                  >
                    <div v-if="followUpList.length < 8">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import orderRow from "@/components/order/orderRow";
import { getAction, postAction } from "@/api/manage";

export default {
  components: {
    orderRow,
  },
  data() {
    return {
      params: {
        orderItemId: [],
      },
      options: [],
      rules: {
        abnormalType: [
          { required: true, message: "请选择异常类型", trigger: "change" },
        ],
        // orderItemId: [
        //   { required: true, message: "请选择涉及商品", trigger: "change" },
        // ],
        description: [
          { required: true, message: "请输入异常描述", trigger: "change" },
        ],
      },
      sourceList: [],
      remark: "",
      showEdit: false,
      previewVisible: false,
      previewImage: "",
      followUpList: [],
      remarkInfo: {
        orderItems: [],
      },
      baseApl: process.env.VUE_APP_BASE_API,
      loading: false,
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      followUpInfo: {},
    };
  },
  created() {
    this.getAbnormalType();
  },
  methods: {
    // 选择来源人
    onSource(e) {
      delete this.params.sourceName;
      delete this.params.sourcePhone;
      if (e != "qt") {
        this.params.sourceName = e.split(",")[0];
        this.params.sourcePhone = e.split(",")[1];
        for(let i of this.sourceList){
          if(i.itemValue==e.split(",")[1]&&i.sourceWorkerId) return this.params.sourceWorkerId=i.sourceWorkerId
        }
      }
    },
    // 获取异常类型
    getAbnormalType() {
      getAction("/common/api/dictItem/find_sys_dict_item", {
        dictCode: "abnormal_type",
      }).then(({ data }) => {
        console.log(data);
        if (data.code == 0) this.options = data.data;
      });
    },
    add(item) {
      console.log(item)
      this.remarkInfo = item;
      if (item.workerName) {
        this.sourceList.push({
          itemText: item.workerName,
          itemValue: item.workerPhone,
          sourceWorkerId:item.workerId
        });
      }
      if (item.orderExpand && item.orderExpand.pickupWorkerName&&item.childOrder)
        this.sourceList.push({
          itemText: item.orderExpand.pickupWorkerName,
          itemValue: item.orderExpand.pickupWorkerPhone,
          sourceWorkerId:item.childOrder.workerId
        });
      if (item.orderPickupCar && item.orderPickupCar.driverName)
        this.sourceList.push({
          itemText: item.orderPickupCar.driverName,
          itemValue: item.orderPickupCar.driverPhone,
        });
      this.sourceList.push({ itemText: "其他", itemValue: "qt" });
      this.showEdit = true;
    },
    // 备注弹窗关闭
    remarkClose() {
      this.params = {
        orderItemId: [],
      };
      this.showEdit = false;
      this.remark = "";
      this.followUpList = [];
      this.sourceList = [];
      this.$refs["ruleForm"].resetFields();
    },
    // 订单跟进拍照
    followUpChange({ fileList }) {
      this.followUpList = fileList;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    submitForm() {
      this.$message.closeAll();
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let imgList = this.followUpList.map(
            (i) => i.url || i.response.data.url
          );
          this.loading = true;
          let params = Object.assign(this.params, {
            abnormalImage: imgList.join(","),
            orderId: this.remarkInfo.id,
            orderItemIds: this.params.orderItemId.join(","),
          });
          postAction("/order/api/abnormal/add", this.$qs.stringify(params))
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$emit("ok");
                this.remarkClose();
              } else {
                this.$message(res.data.message);
              }
            })
            .finally(() => {
              this.remarkClose();
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.el-form-item {
  margin-bottom: 16px;
}
.imgs {
  position: relative;
  margin-right: 0;

  img {
    width: 80px;
    height: 80px;
    &:last-child {
      margin-right: 0;
    }
  }
  .count {
    position: absolute;
    width: 100%;
    height: 24px;
    background: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    bottom: 0;
    left: 0;
    padding: 0 5px;
    .span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
/deep/.el-checkbox-group {
  .sanjiao {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 0;
    height: 0;
    border-right: 18px solid #3455d3;
    border-bottom: 18px solid transparent;
    border-left: 18px solid transparent;
    .el-icon-check {
      font-size: 12px;
      color: #fff;
      position: absolute;
      left: 7px;
      top: 1px;
    }
  }
  .is-checked {
    .sanjiao {
      opacity: 1;
    }
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    border-radius: 2px;
    background: #3455d3;
  }
  .el-checkbox-button + .el-checkbox-button {
    margin-left: 10px;
  }
  .el-checkbox-button {
    .el-checkbox-button__inner {
      border: 0;
      padding: 2px;
      border-radius: 0px;
      border: 0;
    }
  }
}
.inputs {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  height: 40px;
  margin-left: -25px;
  .default-input {
    width: 48%;
  }
}
/deep/.default-input {
  width: 100%;
  textarea {
    height: 80px;
  }
  .el-input__suffix {
    width: auto;
  }
  .el-input__inner {
    width: 100%;
  }
}
#orderlist /deep/ .el-input__inner {
  height: 34px !important;
  margin-top: 0 !important;
}
.increase_price_form {
  background: #fff;
  padding: 20px;
  .zhuijia {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .default-input {
      width: 77%;
      &/deep/.el-input__suffix {
        width: auto !important;
      }
    }
    .default-input-remark {
      width: 93%;
      height: 80px;
      &/deep/textarea {
        height: 100%;
        border-radius: 2px;
        font-size: 12px;
        resize: none;
      }
    }
  }
}
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

#orderlist /deep/.genjinupload {
  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }

  .ant-upload-list {
    // height: 80px !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }
}
</style>
<style lang="scss">
.wuliutooltip {
  background: #fff6e7 !important;
  color: #5e6066 !important;
  max-width: 232px;
  line-height: 16px;
  .popper__arrow {
    display: none !important;
  }
}
</style>